const articles = document.getElementById('blog-grid');
let next_url = articles.dataset.nextUrl;

const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
async function getNextPage() {
  try {
    let res = await fetch(next_url)
      .then(response => response.text())
      .then((responseText) => {
        const productGrids = new DOMParser().parseFromString(responseText, 'text/html').getElementById('blog-grid');
        const newArticles = productGrids.querySelectorAll('.blog-articles__article');
        const newURL = productGrids.dataset.nextUrl;
        
        load_more_spinner.style.display = 'none';
        if(newURL){          
          load_more_btn.style.display = 'block';          
        }
        next_url = newURL;
        newArticles.forEach((i) => {
          articles.appendChild(i);
        });
      });
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'block';
  let nextPage = await getNextPage();
}